import {Component, OnInit} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: true,
    imports: [NgFor, RouterLink, NgClass]
})
export class SettingsComponent implements OnInit {
  items: any[] = [
    {name: 'Partenaires logement', url: '/admin/settings/housing-partner', class: 'housing-partner'},
    {name: 'Clefs de traductions', url: '/admin/settings/i18n', class: 'i18n'},
    {name: 'Bibliothèque dev', url: '/admin/dev-kit', class: 'dev'},
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
